import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from 'app/routes/app.routes';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class SemesterService {
  private baseUrl = ApiRoutes.api.baseUrl;
  private routes = ApiRoutes.api;
  constructor(private http: HttpClient, private httpService: HttpService) { }

  addSemester(payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.semester.add,
      method: 'post',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  allSemesters(pagination?: { page?: number; limit?: number }) {
    const params: any = {};

    if (pagination) {
      if (pagination.page) params.page = pagination.page;
      if (pagination.limit) params.limit = pagination.limit;
    }

    return this.httpService.makeRequest({
      path: this.routes.semester.retrieve,
      method: 'get',
      options: { params },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  editSemester(id: string, payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.semester.edit,
      method: 'put',
      options: { id, body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  activeSemester() {
    return this.httpService.makeRequest({
      path: this.routes.semester.activeSemester,
      method: 'get',
      options: {},
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  deleteSemester(id: string) {
    return this.httpService.makeRequest({
      path: this.routes.semester.delete,
      method: 'delete',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  bulkDelete(payload: { ids: number[] }) {
    return this.httpService.makeRequest({
      path: this.routes.semester.bulkDelete,
      method: 'delete',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getSemesterDetails(id: string) {
    return this.httpService.makeRequest({
      path: this.routes.semester.retrieveSingle,
      method: 'get',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  setActiveSemester(is_current: boolean, id: string) {
    return this.httpService.makeRequest({
      path: this.routes.semester.setActiveSemester,
      method: 'post',
      options: { id, body: { is_current } },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }
}
